"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useGiveToday;
const cms_fetch_1 = __importDefault(require("~/helpers/cms-fetch"));
const page_data_utils_1 = require("~/helpers/page-data-utils");
const promise = (0, cms_fetch_1.default)('give-today');
function testDates(startDateStr, endDateStr) {
    const now = Date.now();
    const start = new Date(startDateStr).valueOf();
    const end = new Date(endDateStr).valueOf();
    return start && end && now >= start && now <= end;
}
function useGiveToday() {
    const giveData = (0, page_data_utils_1.useDataFromPromise)(promise);
    return giveData ? Object.assign(Object.assign({}, giveData), { showButton: testDates(giveData.menu_start, giveData.menu_expires), showLink: testDates(giveData.start, giveData.expires) }) : {};
}
